'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextArea;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TextArea(props) {
  var _onChange = props.onChange || function (f) {
    return f;
  };

  return _react2.default.createElement(
    'div',
    { className: _styles2.default.toString() },
    _react2.default.createElement(
      'label',
      { htmlFor: props.id },
      props.name
    ),
    _react2.default.createElement('textarea', {
      onChange: function onChange(e) {
        return _onChange(e);
      },
      placeholder: props.placeholder
    })
  );
}

TextArea.propTypes = {
  id: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  name: _propTypes2.default.string,
  placeholder: _propTypes2.default.string
};

TextArea.defaultProps = {
  onChange: function onChange() {},
  name: '',
  placeholder: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/TextArea/index.js
// module id = 1608
// module chunks = 0